// Standalone entry point for Cropwise Accounts authentication pages.
// Loads only the minimal JS and CSS needed for login/signup — no jQuery,
// Bootstrap, React, moment, or other CWO operations dependencies.

// Noto Sans font
import './vendor/fonts/notosans/notosans-vf.scss';

// Country flag sprites (bundled SVGs). Imported before the app styles so the
// signup field-flag overrides in application.scss win on shared properties
// (position/width) against the flag-icons `.fi` base rules.
import 'flag-icons/css/flag-icons.min.css';

// Cropwise Accounts styles (layout + error modal)
import './stylesheets/application.scss';

// Vanilla JS initialization — replaces jQuery-based onElementExistRunOnce.
// The `.cropwise-accounts-login-layout` element is always present when
// this pack is loaded, so a simple DOMContentLoaded guard is sufficient.
import initCropwiseAccountsLoginLayout from './views/login';
import { initIdpChangePopupResult } from './views/change_idp/idp_popup_result';
import { initAnalytics } from './analytics';
import { initViewportHeightTracking } from './helpers/viewport_height';

// Lightweight replacement for Bootstrap's alert dismiss behavior.
// Listens for clicks on elements with data-dismiss="alert" and removes
// the closest `.alert` container from the DOM.
const initAlertDismissHandlers = () => {
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    if (!target) return;
    const dismissTrigger = target.closest('[data-dismiss="alert"]');
    if (!dismissTrigger) return;
    event.preventDefault();
    const alertElement = dismissTrigger.closest('.alert');
    if (alertElement) {
      alertElement.remove();
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  void initAnalytics();
  initCropwiseAccountsLoginLayout();
  initIdpChangePopupResult();
  initAlertDismissHandlers();
  initViewportHeightTracking();
});
